import { useEffect } from 'react';

const UtmUpdate = () => {

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utm_campaign = decodeURIComponent(urlParams.get("utm_campaign")?.trim() || "");
    // const utm_source = decodeURIComponent(urlParams.get("utm_source")?.trim() || "");

    let newUrl;

    switch (utm_campaign) {
      case "CC-Generic-Phrase_Exact-May23":
        newUrl = "https://wa.me/+911149061000?text=Hello%2C%20I%20have%20a%20question%20about%20Celebrity%20Cruise%21";
        break;
      case "CC-Search-G_L-HighIntent-Exact_Phrase-LD":
        newUrl = "https://wa.me/+911149061000?text=Hello%2C%20I'm%20interested%20in%20taking%20a%20cruise%20vacation%20with%20Celebrity%20Cruises.";
        break;
      case "RCI_DG_Google_Suggested_9Jul25":
        newUrl = "https://wa.me/+911149061000?text=Hey%2C%20Curious%20about%20Royal%20Caribbean%20cruises";
        break;
      default:
        newUrl = "https://wa.me/911149061000?text=Hello%2C%20I'm%20Interested%20in%20taking%20a%20cruise%20vacation";
    }


    // // UTM Source Override
    // if (utm_source === "Print") {
    //   newUrl = "https://wa.me/911149061000?text=Hi%20TIRUN%2C%20saw%20your%20ad%20today.%20Want%20to%20plan%20a%20cruise%20vacation!";
    // }

    // Update WhatsApp Button
    function updateWhatsAppButton() {
      const waButton = document.querySelector(".wa-chat-box-content-send-btn");
      if (waButton) {
        waButton.setAttribute("href", newUrl);
        console.log("WhatsApp link updated successfully.");
      } else {
        console.log("WhatsApp button not found, retrying...");
        setTimeout(updateWhatsAppButton, 500);
      }
    }

    updateWhatsAppButton();
  }, []);
};

export default UtmUpdate ;